module.exports = __webpack_public_path__ + "static/GroovyDoodle-12a7872dfb5f22c22014ea662c04bcb6.png";